// vue3-migration -- Element
import langEs from 'element-plus/es/locale/lang/es';
import translations from './translations.json';
import 'moment/locale/es';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langEs,
};
